module.exports = __webpack_public_path__ + "img/MEDIA060.3823a063.jpg";